import { DefaultResponseModel } from "@/types/http";
import http, {
  APPLICATION_X_WWW_FORM_URLCODED,
  CONTENT_TYPE_MULTIPART_FORM_DATA,
} from "../utils/http-client";
import { BookModel } from "@/types/book";

export interface UploadResponseModel {
  file_md5: number;
  file_name: string;
  file_size: number;
  file_type: string;
  url: string;
  id: string;
}

//上传文件
export const upload = (
  file: any,
  progress_callback: (progress: number) => void,
  directory_id?: string
) => {
  return http.post<DefaultResponseModel<UploadResponseModel>>({
    url: "/api/upload",
    data: {
      file: file,
      directory_id: directory_id,
    },
    unprocessed: true,
    config: {
      headers: {
        "Content-Type": CONTENT_TYPE_MULTIPART_FORM_DATA,
      },
      onUploadProgress(progressEvent) {
        progress_callback?.(progressEvent.progress ?? 0);
      },
    },
  });
};

// export const upload = (file: any) => {
//   return http.post<DefaultResponseModel<string>>({
//     url: "/api/upload",
//     data: {
//       file: file,
//     },
//     unprocessed: true,
//     config: {
//       headers: {
//         "Content-Type": CONTENT_TYPE_MULTIPART_FORM_DATA,
//       },
//     },
//   });
// };

//上传文件
export const uploadPDF = (pdf: any) => {
  return http.post<DefaultResponseModel<Array<string>>>({
    url: "/api/convert_pdf",
    data: {
      file: pdf,
    },
    unprocessed: true,
    config: {
      headers: {
        "Content-Type": CONTENT_TYPE_MULTIPART_FORM_DATA,
      },
    },
  });
};

/**
 * 创建一本草稿状态的新书，返回新书的实体
 */

export const createBook = (args: any) => {
  return http.post<DefaultResponseModel<BookModel>>({
    data: args,
    url: "/api/book/create",
    unprocessed: true,
  });
};

export const updateBook = (args: any) => {
  return http.put<DefaultResponseModel>({
    data: args,
    url: "/api/book/update",
    config: {
      headers: {
        "Content-Type": CONTENT_TYPE_MULTIPART_FORM_DATA,
      },
    },
    unprocessed: true,
  });
};

export interface UploadedFileModel {
  file_md5: string;
  file_name: string;
  file_size: number;
  file_type: string;
  file_url: string;
  original_name: string;
  upload_time: string;
  id: string;
  directory: string;
  extra_info: any;
}

/**
 * 获取用户已上传文件
 */
export const getAllUploadedFiles = () => {
  return http.get<Array<UploadedFileModel>>({
    url: "/api/upload/files",
  });
};

/**
 * 删除文件
 */
export const deleteUploadedFile = (id: string) => {
  return http.post<DefaultResponseModel>({
    url: "/api/upload/delete",
    data: {
      id,
    },
    unprocessed: true,
  });
};

export interface FileOwnerImageModel {
  create_time: string;
  file_name: string;
  file_url: string;
  id: string;
  page_number: number;
}

/**
 * 删除文件
 */
export const getImagesOfOwner = (owner_id: string) => {
  return http.get<Array<FileOwnerImageModel>>({
    url: "/api/upload/file/images",
    params: {
      id: owner_id,
    },
  });
};
